export default __webpack_public_path__ + "static/media/gr_logo_desk.2f283702.svg";